
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';
import Button from '@/components/UI/Button.vue';
import AttachmentsField from '@/components/fields/AttachmentsField.vue';
import LookupMailbox from '@/components/UI/LookupMailbox.vue';
import { UploadingFilesObjectForTable } from '@/models/main';

import { validateEmails } from '@/utils/Common';
import { ZammadTicketData } from '@/models/jobTicket';

import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', {
  ...required,
  message: 'This field is required',
});

@Component({
  components: {
    Button,
    Icon,
    AttachmentsField,
    LookupMailbox,
  },
})
export default class ZammadTicketCreationForm extends Vue {
  @Prop({ type: String, required: false, default: '' }) public type: string;
  @Prop({ type: Boolean, required: false, default: false }) public loading: boolean;
  @Prop({ type: Object, required: true }) public formData: ZammadTicketData;
  @Prop({ type: Number, required: true }) public jobId: number;
  @Prop({ type: String, required: false }) private reference: string;

  public toInputHasError = false;
  private validateEmails = validateEmails;

  public uploadError = '';
  private files: File[] = [];
  public filesObjectsForTable: UploadingFilesObjectForTable[] = [];

  public validateEmailToInput() {
    this.toInputHasError = !this.formData.toChips.length;
  }

  public setChips(label: string, chips: string[]) {
    this.formData[`${label}Chips`] = chips;
    this.validateEmailToInput();
  }

  public async submitFromClicked(): Promise<void> {
    if (this.type !== 'r4c' && this.$ability.can('staff', 'Job')) {
      this.validateEmailToInput();
    }
    const form = this.$refs.newMsgForm as HTMLFormElement;
    if (form && !this.toInputHasError) {
      const success = await form.validate();
      if (success) {
        this.$emit('submit', { ...this.formData, is_rfc: this.type === 'r4c' ? true : false, attachments: this.files });
      }
    }
  }

  public filesAdded(files: File[]): void {
    this.uploadError = '';
    this.filesObjectsForTable = [];
    this.files = [...this.files, ...files];
    if (this.files.length > 5) {
      this.uploadError = 'You are only allowed to upload a maximum of 5 files';
      this.files.splice(5);
    }
    this.files.map(file => {
      this.filesObjectsForTable.push({
        name: file.name,
        size: file.size,
      });
    });
  }

  public deleteFiles(item: UploadingFilesObjectForTable): void {
    const fileIdx = this.files.findIndex(x => x.name === item.name);
    if (fileIdx >= 0) {
      this.files.splice(fileIdx, 1);
      this.filesObjectsForTable.splice(fileIdx, 1);
      this.uploadError = '';
    }
  }

  private mounted() {
    if (this.jobId && this.jobId >= 0) {
      this.formData.subject = `Update to job #${this.jobId}`;
      if (this.reference && this.reference !== '') {
        this.formData.subject += `, ref: ${this.reference}`;
      }
    }
  }
  //
}
